/**
 * Coure SMS Delivery Service
 * Coure SMS Delivery service Api 
 *
 * OpenAPI spec version: v1.0
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { SmsBillingSetting } from '../model/smsBillingSetting';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class SmsBillingSettingsService {

    protected basePath = 'http://10.1.1.123:30116';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param name 
     * @param startIndex 
     * @param count 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsBillingSettingsGetAllSmsBillingSettings(name: string, startIndex: number, count: number, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public smsBillingSettingsGetAllSmsBillingSettings(name: string, startIndex: number, count: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public smsBillingSettingsGetAllSmsBillingSettings(name: string, startIndex: number, count: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public smsBillingSettingsGetAllSmsBillingSettings(name: string, startIndex: number, count: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (name === null || name === undefined) {
            throw new Error('Required parameter name was null or undefined when calling smsBillingSettingsGetAllSmsBillingSettings.');
        }

        if (startIndex === null || startIndex === undefined) {
            throw new Error('Required parameter startIndex was null or undefined when calling smsBillingSettingsGetAllSmsBillingSettings.');
        }

        if (count === null || count === undefined) {
            throw new Error('Required parameter count was null or undefined when calling smsBillingSettingsGetAllSmsBillingSettings.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get(`${this.basePath}/api/SmsBillingSettings/getall/${encodeURIComponent(String(name))}/${encodeURIComponent(String(startIndex))}/${encodeURIComponent(String(count))}`,
            {
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param model 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsBillingSettingsPostSmsBillingSettings(model: SmsBillingSetting, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public smsBillingSettingsPostSmsBillingSettings(model: SmsBillingSetting, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public smsBillingSettingsPostSmsBillingSettings(model: SmsBillingSetting, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public smsBillingSettingsPostSmsBillingSettings(model: SmsBillingSetting, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (model === null || model === undefined) {
            throw new Error('Required parameter model was null or undefined when calling smsBillingSettingsPostSmsBillingSettings.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<number>(`${this.basePath}/api/SmsBillingSettings/postsettings`,
            model,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param model 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsBillingSettingsUpdateSmsBillingSettings(model: SmsBillingSetting, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public smsBillingSettingsUpdateSmsBillingSettings(model: SmsBillingSetting, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public smsBillingSettingsUpdateSmsBillingSettings(model: SmsBillingSetting, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public smsBillingSettingsUpdateSmsBillingSettings(model: SmsBillingSetting, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (model === null || model === undefined) {
            throw new Error('Required parameter model was null or undefined when calling smsBillingSettingsUpdateSmsBillingSettings.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put(`${this.basePath}/api/SmsBillingSettings/update`,
            model,
            {
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
